import { Typography } from "@mui/material";
import { ICatalogOffer } from "@features/cart/ICart";
import { useStyle } from "./homeBroadbandOfferStyle";
import { Trans, useTranslation } from "react-i18next";
import { BRAND_NAME } from "@constants";
import { IEirSalesPrequal } from "@modules/eirSalesFacade/interfaces/models/IEirSalesPrequal";
import { OfferCard } from "@features/offer/OfferCard";
import { IFetchState } from "itsf-ui-common";
import { useCallback } from "react";
import { CheckCircle } from "@mui/icons-material";
import { HomeBroadbandPrequalAddress } from "@features/home/common/HomeBroadbandPrequalAddress/HomeBroadbandPrequalAddress";
import { WarningBanner } from "@common/WarningBanner/WarningBanner";
import { useDeviceType } from "@hooks/useDeviceType";
import { getOfferPrice } from "@utils/offerUtils";

interface IParams {
    offer: ICatalogOffer;
    prequal: IEirSalesPrequal;
    hasBroadbandOfferInCart?: boolean;
    addBroadbandOfferState: IFetchState;
    handleChangeAddress(): void;
    handleAddBroadbandOffer(offer: ICatalogOffer, prequal: IEirSalesPrequal): void;
    isSidePanel?: boolean;
}

export const HomeBroadbandOffer = (props: IParams) => {
    const {
        offer,
        prequal,
        handleChangeAddress,
        handleAddBroadbandOffer,
        hasBroadbandOfferInCart,
        addBroadbandOfferState,
        isSidePanel,
    } = props;
    const { t } = useTranslation(["home", "glossary"]);
    const { classes } = useStyle();
    const { isMobile } = useDeviceType();

    const handleClickBuyNow = useCallback(() => {
        handleAddBroadbandOffer(offer, prequal);
    }, [handleAddBroadbandOffer, offer, prequal]);

    const additionalInfoComponent = (
        <WarningBanner
            content={<Trans i18nKey="broadbandOnlyWithMobile" ns="home" values={{ brand: BRAND_NAME }} />}
            icon={<CheckCircle />}
        />
    );

    return (
        <div className={classes.container}>
            <Typography
                color="secondary"
                paddingTop={isSidePanel ? 4 : 0}
                textAlign="center"
                variant={isSidePanel ? "h2" : "h1"}
            >
                {isMobile ? t("home:broadbandAvailableInOneLine") : <Trans i18nKey="broadbandAvailable" ns="home" />}
            </Typography>
            <HomeBroadbandPrequalAddress address={prequal.address} handleChangeAddress={handleChangeAddress} />
            <OfferCard
                addOfferState={addBroadbandOfferState}
                additionalInfoComponent={additionalInfoComponent}
                handleClickBuyNow={handleClickBuyNow}
                isOfferAlreadyAdded={hasBroadbandOfferInCart}
                isSidePanel={isSidePanel}
                offer={offer}
                offerAlreadyAddedText={t("glossary:broadbandAddedToBasket")}
                price={getOfferPrice(offer)}
            />
        </div>
    );
};
